import type { FC } from "react";
import { Card, CardActionArea, CardHeader } from "@mui/material";
import { Link } from "react-router-dom";
import type { UserType } from "@/types/graphql/partner";
import { UserAvatar } from "@/partner/shared/ui";
import { getUserDisplayName } from "@/partner/shared/utils";
import { PagePaths } from "@/partner/shared/constants";

export interface UserCardProps {
  user: UserType;
}

export const UserCard: FC<UserCardProps> = ({ user }) => {
  return (
    <Card sx={{ borderRadius: 0, bgcolor: "transparent" }}>
      <CardActionArea
        component={Link}
        to={PagePaths.userSettings}
        disableRipple
        sx={{
          "&:hover": {
            backgroundColor: "action.hover",
          },
        }}
        slots={{ focusHighlight: () => null }}
      >
        <CardHeader
          avatar={
            <UserAvatar
              userId={user.id}
              avatarUrl={user.avatar?.url}
              size={40}
              sx={{ bgcolor: "primary.main" }}
            />
          }
          title={getUserDisplayName(user)}
          subheader={user.email}
          slotProps={{
            content: { sx: { minWidth: 0 } },
            title: { fontSize: 16, fontWeight: 600, noWrap: true },
            subheader: { fontSize: 14, fontWeight: 500, noWrap: true },
          }}
          sx={{ p: 2 }}
        />
      </CardActionArea>
    </Card>
  );
};
